import { Logger } from '@main/utils/logger';
import { AgentStatusInfo, publishEvent } from '@salesforce/scv-connector-base';
import type { StatusSyncAircallToCrmEventPublisher } from '@usecases/status-sync-aircall-to-crm.usecase';

export class StatusSyncAircallToCrmPublisher
  implements StatusSyncAircallToCrmEventPublisher
{
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publishStatus(statusId: string): Promise<void> {
    this.logger.info('Publisher: Sync user status from Aircall to CRM', {
      action: 'StatusSyncAircallToCrm',
      statusId,
    });

    publishEvent({
      /**
       * 'SET_AGENT_STATUS' is not added to eventType(bug in salesforce scv library).
       * Therefore we have to manually type cast.
       */
      eventType: <never>'SET_AGENT_STATUS',
      payload: new AgentStatusInfo({ statusId }),
      registerLog: false,
    });
  }
}
